import script from "./YelloopCheckTabInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./YelloopCheckTabInfo.vue?vue&type=script&lang=ts&setup=true"

import "./YelloopCheckTabInfo.vue?vue&type=style&index=0&id=27528689&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27528689"]])

export default __exports__